/*
 * Redeem Success Ctrl
 */

module.controller('successRedeemCtrl', ['$scope', '$state', '$stateParams', function ($scope, $state, $stateParams) {
  $scope.successMessage = $stateParams.successMessage;

  $scope.goToLogin = function(){
    $state.go('root.login', { username: $stateParams.username });
  };
}]);
